export function regexHourCheck(hours){
  return /^([01]\d)|([2][0-3])$/.test(hours);
}

export function regexFullTimeCheck(time){
  return /^((\d)|(([01]\d)|([2][0-3]))):([0-5]\d)$/.test(time);
}